<template>
<div class='full-size home page container'>
   <div class='row'>
      <parallax :class='"box-wrapper col6 col-1"'
                :speedFactor='0.1'>
         <div class='box wide'>
            <parallax :class='"absolute full-size"'
                      :speedFactor='0.3'
                      wrapped='true'>
               <div class='cover full-size'
                          :style="{ backgroundImage: `url('${image}')` }"></div>
            </parallax>
         </div>
         <p class='title'>Prague Castle</p>
      </parallax>
      
      <parallax :class='"box-wrapper col6 col-2"'
                :speedFactor='-0.2'>
         <div class='box wide'>
            <parallax :class='"absolute full-size"'
                      :speedFactor='0.3'
                      wrapped='true'>
               <div class='cover full-size'
                          :style="{ backgroundImage: `url('${image2}')` }"></div>
            </parallax>
         </div>
          <p class='title'>Austrian parliament</p>
      </parallax>

      <parallax :class='"box-wrapper col4 col-3"'
                :speedFactor='-0.5'>
         <div class='box'>
            <parallax :class='"absolute full-size"'
                      :speedFactor='0.3'
                      wrapped='true'>
               <div class='cover full-size'
                          :style="{ backgroundImage: `url('${image3}')` }"></div>
            </parallax>
         </div>
          <p class='title'>Berlin Street</p>
      </parallax>

       <parallax :class='"box-wrapper col6 col-4"'
                :speedFactor='-0.4'>
         <div class='box wide'>
            <parallax :class='"absolute full-size"'
                      :speedFactor='0.3'
                      wrapped='true'>
               <div class='cover full-size'
                          :style="{ backgroundImage: `url('${image4}')` }"></div>
            </parallax>
         </div>
          <p class='title'>Flat in Prague Sumavska XIII</p>
      </parallax>
      
   </div>
</div>

</template>

<script>
import EventBus from '@/config/event-bus';
import BasePage from '@/mixins/basePage';
import Transition from '@/mixins/transition';
import Parallax from '@/components/parallax';

export default {
    name: 'home',
    mixins: [

        BasePage,

        Transition
    ],

    components: {
        Parallax
    },

    computed: {
        isMobile()  {
            return this.$store.getters['app/getMobile']
        },
        image() {
          return "/static/prague.jpg"
        },
        image2() {
          return "/static/parlament.jpg"
        },
        image3() {
          return "/static/berlin.jpg"
        },
        image4() {
          return "/static/suma.jpg"
        }
    },

    methods: {
    },

    created()  {},

    updated()  {},

    mounted()  {
        var self = this
    },

    beforeDestroy()  {}

}

</script>

<style lang="scss" scoped="">
.home {
  padding-bottom: 8vw;
}

.cover{
  background-size: cover;
  background-position: center;
}

.box-wrapper{
  padding: 4vw;
}

.box {
  position: relative;
  box-shadow: 0px 2vw 6vw 0px rgba(0,0,0,.3);
  // margin: 4vw;

  .parallax-wrapper{
    top: 0;
  }

  &:before {
       content: '';
       padding-bottom: 130%;
       display: block;
  }

   &.wide {
      &:before {
         content: '';
         padding-bottom: 60%;
         display: block;
      }
   }
}

.title{
  text-align: center;
  color: black;
}

@media (min-width: 992px) {
  .col-1{
    margin-left: 8vw;
  }


  .col-2{
    margin-left: 0vw;
  }

  .col-3{
    margin-left: 12vw;
  }

  .col-4{
    margin-top: -6vw;
    margin-left: 8vw;
  }
}

.row {
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
}

.big-text {
   font-size: 36px;
   @media (min-width: 768px) {
      font-size: 42px;
   }
   @media (min-width: 992px) {
      font-size: 5vw;
   }
   @media (min-width: 1200px) {
      font-size: 4vw;
   }
}
</style>



// WEBPACK FOOTER //
// Home.vue?668e75e4